<div class="ai-assistant-overlay" *ngIf="isVisible" (click)="onOverlayClick($event)">
  <div class="ai-assistant-modal" (click)="$event.stopPropagation()">
    <!-- Modal Header -->
    <div class="ai-assistant-header">
      <div class="ai-assistant-header-content">
        <div class="ai-assistant-title-section">
          <i class="fas fa-robot ai-assistant-icon"></i>
          <div>
            <h3 class="ai-assistant-title">{{ currentMode === 'leads' ? 'AI Lead Advisor' : 'AI Help Assistant' }}</h3>
            <p class="ai-assistant-subtitle">{{ currentMode === 'leads' ? (leadsContext ? 'Ask about ' + leadsContext.contactName + ' — when to contact, follow-up tips, and talking points.' : 'Ask about your leads, when to contact, and networking tips.') : "Ask me anything about the app. I'm here to help!" }}</p>
          </div>
        </div>
        <button type="button" class="ai-assistant-close" (click)="closeModal()" aria-label="Close">
          <i class="fas fa-times"></i>
        </button>
      </div>
    </div>

    <!-- Modal Body -->
    <div class="ai-assistant-body">
      <div class="ai-assistant-actions" *ngIf="supportChatHistory.length > 0">
        <button type="button" class="ai-assistant-clear" (click)="clearSupportChat()">
          <i class="fas fa-trash-alt me-2"></i>Clear chat
        </button>
      </div>

      <div class="ai-assistant-chat-container">
        <div class="ai-assistant-messages" #messagesContainer>
          <div class="ai-assistant-empty" *ngIf="supportChatHistory.length === 0 && !isHelpBotLoading">
            <div class="ai-assistant-idle-icon"><i class="fas fa-robot"></i></div>
            <p class="ai-assistant-idle-text">How can I help you today?</p>
            <div class="ai-assistant-suggested-questions">
              <button
                *ngFor="let question of suggestedQuestions"
                type="button"
                class="ai-assistant-suggested-question"
                (click)="handleSuggestedQuestionClick(question)">
                {{ question }}
              </button>
            </div>
          </div>

          <div *ngFor="let msg of supportChatHistory; let i = index" 
               class="ai-assistant-bubble-wrap" 
               [class.user]="msg.role === 'user'" 
               [class.bot]="msg.role === 'assistant'">
            <div class="ai-assistant-bubble">
              <span class="ai-assistant-content">{{ msg.content }}</span>
              
              <!-- Article Buttons -->
              <div class="ai-assistant-buttons" *ngIf="msg.role === 'assistant' && msg.articleIds && msg.articleIds.length > 0">
                <button
                  *ngFor="let articleId of msg.articleIds"
                  type="button"
                  class="ai-assistant-button"
                  (click)="openArticleInNewTab(articleId)">
                  <i class="fas fa-external-link-alt me-2"></i>{{ getArticleTitle(articleId) }}
                </button>
              </div>

              <!-- Related Links -->
              <div class="ai-assistant-related-links" *ngIf="msg.role === 'assistant' && msg.relatedLinks && msg.relatedLinks.length > 0">
                <div class="ai-assistant-related-label">Helpful links:</div>
                <button
                  *ngFor="let link of msg.relatedLinks"
                  type="button"
                  class="ai-assistant-related-link"
                  (click)="handleRelatedLinkClick(link)">
                  <i class="fas fa-external-link-alt me-2"></i>
                  {{ getLinkActionText(link) }}
                </button>
              </div>

              <!-- Related Questions -->
              <div class="ai-assistant-related-questions" *ngIf="msg.role === 'assistant' && msg.relatedQuestions && msg.relatedQuestions.length > 0">
                <div class="ai-assistant-related-label">Related questions:</div>
                <button
                  *ngFor="let question of msg.relatedQuestions"
                  type="button"
                  class="ai-assistant-related-question"
                  (click)="handleRelatedQuestionClick(question)">
                  <i class="fas fa-question-circle me-2"></i>
                  {{ question }}
                </button>
              </div>
            </div>
          </div>

          <!-- Loading Indicator -->
          <div class="ai-assistant-bubble-wrap bot" *ngIf="isHelpBotLoading">
            <div class="ai-assistant-bubble ai-assistant-loading">
              <span class="ai-assistant-content">
                <i class="fas fa-spinner fa-spin me-2"></i>Thinking
                <span *ngIf="remainingWaitSeconds > 0" class="ai-assistant-timer">
                  {{ remainingWaitSeconds }}s
                </span>
                <span *ngIf="remainingWaitSeconds === 0">…</span>
              </span>
            </div>
          </div>
        </div>

        <!-- Error Message -->
        <div class="ai-assistant-error" *ngIf="helpBotError">
          <i class="fas fa-exclamation-circle me-2"></i>{{ helpBotError }}
        </div>

        <!-- Input Area -->
        <div class="ai-assistant-input-wrap">
          <input
            type="text"
            class="form-control ai-assistant-input"
            placeholder="Ask a question…"
            [(ngModel)]="supportChatInput"
            (keydown.enter)="$event.preventDefault(); sendHelpBotMessage()"
            [disabled]="isHelpBotLoading"
            autocomplete="off" />
          <button
            type="button"
            class="ai-assistant-send"
            (click)="sendHelpBotMessage()"
            [disabled]="isHelpBotLoading || !supportChatInput.trim()">
            <i class="fas fa-paper-plane"></i>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
